import React from 'react'
import { agentColors } from './agentChatLayout'

/**
 * Inline permission summary for hero card body.
 */
export default function AgentAccessSummary({ manifest, compact = false }) {
  if (!manifest) {
    return (
      <div style={{ fontSize: 13, color: agentColors.textMuted, padding: '12px 0' }}>
        Loading your access…
      </div>
    )
  }

  const clients = manifest.clients ?? []
  const sources = manifest.searchable_sources ?? []
  const wikiOn = manifest.wiki_access === true
  const personalAvailable = manifest.personal_kb_available === true
  const noSources = sources.length === 0
  const noWiki = !wikiOn

  const chip = (label, ok, warnText) => (
    <span
      key={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 500,
        background: ok ? '#f5f5f4' : '#fef2f2',
        color: ok ? agentColors.textSecondary : agentColors.danger,
        border: `1px solid ${ok ? agentColors.borderSoft : '#fecaca'}`,
      }}
      title={!ok ? warnText : undefined}
    >
      {label}: {ok ? 'Yes' : 'No'}
    </span>
  )

  return (
    <div
      style={{
        marginTop: compact ? 8 : 14,
        padding: compact ? '12px 14px' : '14px 16px',
        borderRadius: 10,
        background: agentColors.bgCard,
        border: `1px solid ${agentColors.borderSoft}`,
      }}
    >
      <div
        style={{
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          color: agentColors.textMuted,
          marginBottom: 10,
        }}
      >
        Your access
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
        <span
          style={{
            padding: '4px 10px',
            borderRadius: 999,
            fontSize: 12,
            background: '#f5f5f4',
            color: agentColors.textSecondary,
          }}
        >
          Role: {manifest.role}
        </span>
        {chip('Wiki', wikiOn, 'Wiki search unavailable for your role')}
        {chip(
          'Personal',
          personalAvailable,
          'Enable Personal Library in admin settings, then opt in on /personal-knowledge'
        )}
      </div>
      <div style={{ fontSize: 13, color: agentColors.textSecondary, lineHeight: 1.55 }}>
        <div>
          <strong style={{ color: agentColors.textPrimary }}>Clients:</strong>{' '}
          {clients.length ? clients.map((c) => c.name).join(', ') : 'Org-wide docs only'}
        </div>
        <div style={{ marginTop: 4 }}>
          <strong style={{ color: agentColors.textPrimary }}>Sources:</strong>{' '}
          {sources.length ? sources.map((s) => s.label).join(', ') : 'None configured'}
        </div>
        {noSources ? (
          <div style={{ marginTop: 8, fontSize: 12, color: agentColors.danger }}>
            Document search unavailable — contact an admin for source permissions.
          </div>
        ) : null}
        {noWiki ? (
          <div style={{ marginTop: 4, fontSize: 12, color: agentColors.danger }}>
            Wiki search unavailable for your role.
          </div>
        ) : null}
        {personalAvailable ? (
          <div style={{ marginTop: 4, fontSize: 12, color: agentColors.textMuted }}>
            Personal library available — enable via checkbox in chat or search.
          </div>
        ) : null}
        <div style={{ marginTop: 8, fontSize: 12, color: agentColors.textMuted }}>
          Org-wide SOPs are always included alongside client-specific docs.
        </div>
      </div>
    </div>
  )
}
